import { PostedJobManagementServices } from 'admin/services';
import { IExpert } from 'common/models';
import React from 'react';

export const useFullTimeJobPostApplicants = (jobPostId: string) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [applicants, setApplicants] = React.useState<IExpert[]>([]);

  React.useEffect(() => {
    setIsLoading(true);
    PostedJobManagementServices.getFullTimeJobPostApplicants(jobPostId)
      .then((res) => setApplicants(res.data))
      .catch((err) => console.error(err))
      .finally(() => setIsLoading(false));
  }, [jobPostId]);

  return { applicants, isLoading };
};
